import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { BomDetails } from './saleorder/bom-calculation.entity';
import { SoInvoiceDetails } from './saleorder/sale-invoice-details.entity';
import { SaleOrderItems } from './saleorder/sale-order-items.entity';
import { SaleOrder } from './saleorder/sale-order.entitiy';
import { SaleorderModule } from './saleorder/saleorder.module';
import { SaleOrderTrack } from './saleorder/so-track.entity';
import { SalePoDetails } from './saleorder/so_po_details.entity';
import {appSettings} from '../../../config';
import { SoCustomerInvoice } from './saleorder/customer-invoice.entity';
import { InsuranceEntity } from './saleorder/insurance.entity';
import { DocumentsApproval } from './saleorder/entities/documents-approval.entity';
import { RmBomLog } from './saleorder/rm-bom-log.entity';
import { SaleInspectionDetails } from './saleorder/so-inspections.entity';
import { SoProduction } from './saleorder/entities/so-production.entity';
import { SOTransferLog } from './saleorder/so-transfer-log.entity';
import { SaleOrderLog } from './saleorder/so-log.entity';
import { SaleOrderItemsLog } from './saleorder/so-items-log.entity';
import { BomDetailsLog } from './saleorder/bom-details-log.entity';
import { PackingBomLog } from './saleorder/packing-bom-log.entity';
import { ScheduleModule } from '@nestjs/schedule';
import { DomesticSalesEntity } from './saleorder/entities/domestic-sales-entity';
@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
    // host: '142.93.219.119',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.sales_db,
      entities: [SaleOrder,DomesticSalesEntity,SaleOrderItems,SoInvoiceDetails,SalePoDetails, BomDetails,SaleOrderTrack, SoCustomerInvoice,InsuranceEntity, DocumentsApproval,RmBomLog,SaleInspectionDetails, SoProduction,SOTransferLog,SaleOrderLog,SaleOrderItemsLog,BomDetailsLog,PackingBomLog],
      synchronize: false,
      logging: true
  }),
  ScheduleModule.forRoot(),
    SaleorderModule, 

  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
